<app-dialog-banner text="New Ballot" i18n-text [dialogRef]="dialogRef"></app-dialog-banner>

<div class="ballot-stepper" [attr.data-form-ready]="ready ? 'true' : null">
    <mat-stepper [linear]="true" #stepper (selectionChange)="stepChanged($event)">
        @for (state of ['number', 'edit', 'done']; track state) {
            <ng-template [matStepperIcon]="state" let-index="index">
                <ng-container *ngTemplateOutlet="stepCircle; context: { index }"></ng-container>
            </ng-template>
        }

        <mat-step [stepControl]="ballotFS.getFormGroup()" i18n-label label="Meeting">
            <ng-template matStepContent>
                <div class="step-body">
                    <app-field-set [fieldSet]="ballotFS" [isPhone]="false" [initComplete]="ready"></app-field-set>
                </div>
                <div class="step-nav">
                    <span class="spacer"></span>
                    <button mat-raised-button color="primary" data-step-next
                            [disabled]="!ballotFS.getFormGroup().valid" (click)="stepper.next()" i18n>Next</button>
                </div>
            </ng-template>
        </mat-step>

        @for (questionFS of questionSteps; track questionFS; let questionNr = $index) {
            <mat-step [stepControl]="questionFS.getFormGroup()" label="">
                <ng-template matStepContent>
                    <div class="step-body">
                        <app-field-set [fieldSet]="questionFS" [isPhone]="false" [initComplete]="true"></app-field-set>
                    </div>
                    <div class="step-nav">
                        <button mat-button color="warn" data-remove-question
                                (click)="removeQuestion(questionFS, questionNr)" i18n>Remove question</button>
                        <span class="spacer"></span>
                        <button mat-raised-button color="accent" data-step-back (click)="stepper.previous()" i18n>Back</button>
                        <button mat-raised-button color="primary" data-step-next
                                [disabled]="!questionFS.getFormGroup().valid" (click)="stepper.next()" i18n>Next</button>
                    </div>
                </ng-template>
            </mat-step>
        }

        <mat-step i18n-label label="Summary">
            <ng-template matStepContent>
                @if (summary) {
                    <div class="step-body summary">
                        <h3>{{ summary.title }}</h3>
                        <p class="summary-when">
                            {{ summary.opensAt * 1000 | date: 'medium' }} to {{ summary.closesAt * 1000 | date: 'medium' }}
                            <span i18n>in the {{ channelName }} channel</span>
                        </p>
                        <div [innerHTML]="summary.content"></div>

                        <h4 i18n>Items on the agenda</h4>
                        @for (question of summary.questions; track $index) {
                            <div class="summary-question">
                                <strong>{{ $index + 1 }}. {{ question.question }}</strong>
                                <span class="summary-options">
                                    @for (option of question.options; track $index) {
                                        {{ option.name }}@if (!$last) {, }
                                    }
                                </span>
                            </div>
                        } @empty {
                            <p class="summary-note" i18n>
                                <span class="no-questions">No questions yet</span> - usually you want to press the
                                "Add question" button and add questions for people to vote on. You can create the
                                ballot now and add the questions later, but you should add any questions before
                                sending the notifications.
                            </p>
                        }

                        <h4 i18n>Requests on the agenda</h4>
                        @for (agendaRequest of agendaRequests; track agendaRequest.request.id) {
                            <div class="summary-request">
                                <mat-checkbox [(ngModel)]="agendaRequest.included" [disabled]="agendaRequest.pinned"
                                              [attr.data-agenda-request]="agendaRequest.request.id">
                                    {{ agendaRequest.request.refNr }}: {{ agendaRequest.request.title }}
                                    <span class="summary-request-status">({{ agendaRequest.request.srStatus }})</span>
                                </mat-checkbox>
                            </div>
                        } @empty {
                            <p class="summary-note" i18n>
                                No requests are waiting to be discussed in this channel.
                            </p>
                        }
                        @if (agendaRequests.length) {
                            <p class="summary-note" i18n>
                                Requests escalated to this channel stay on each meeting's agenda until they are
                                accepted. Untick any that do not need to be discussed at this meeting.
                            </p>
                        }
                    </div>
                }
                <div class="step-nav">
                    <mat-checkbox [(ngModel)]="sendNotifications" data-field="sendNotifications" i18n>
                        Send notifications to the channel once saved
                    </mat-checkbox>
                    <span class="spacer"></span>
                    <button mat-raised-button color="accent" data-step-back (click)="stepper.previous()" i18n>Back</button>
                    <button mat-raised-button color="accent" data-add-question (click)="addQuestion()" i18n>Add question</button>
                    <button mat-raised-button color="primary" data-save-button
                            [disabled]="saving" (click)="finish()" i18n>Create ballot</button>
                </div>
                @if (sendNotifications) {
                    <p class="summary-note notify-warning" i18n>
                        Notifications can only be sent once, and attachments can only be added after the ballot
                        is saved. Leave this unticked if you plan to attach documents, and send them from the
                        ballot page instead.
                    </p>
                }
            </ng-template>
        </mat-step>

    </mat-stepper>
</div>

<ng-template #stepCircle let-index="index">
    @if (index === 0) {
        <mat-icon class="step-icon">event</mat-icon>
    } @else if (index > questionSteps.length) {
        <mat-icon class="step-icon">fact_check</mat-icon>
    } @else {
        <span class="question-circle" [matTooltip]="questionLabel(questionSteps[index - 1], index - 1)">Q{{ index }}</span>
    }
</ng-template>
